'use client';
import GlobalError from '@/layouts/GlobalError';

export default GlobalError;
